module.exports = __webpack_public_path__ + "static/media/twoColAd.3a59668f.png";